import { homeRoute } from './home.route';
import { projectDetailRoute } from './project-detail.route';
import { prototypeDetailRoute } from './prototype-detail.route';
import { rootRoute } from './root.route';
import { usersRoute } from './users.route';

/**
 * The route tree, assembled by hand.
 *
 * **Code-based, not file-based.** The file-based router generates
 * `routeTree.gen.ts` from a Vite plugin, which means `pnpm typecheck` and
 * `pnpm lint` only pass if a build has run first — a generated file the CI
 * pipeline (`install → lint → typecheck → test → build`) does not have yet at
 * the point it needs it. Three routes do not justify importing that ordering
 * problem, and this file stays the one place the shape of the app is stated.
 */
export const routeTree = rootRoute.addChildren([
  homeRoute,
  projectDetailRoute,
  prototypeDetailRoute,
  usersRoute,
]);
